import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useSyncUFCEventDetails = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useMutation(async () => {
    const token = await getAccessTokenSilently();
    return axios.get(
      `${process.env.REACT_APP_API_URL}/api/events/sync-details`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  });
};
